//Modal for editing a protectee
import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
// import './addManagedAccountModal.scss'
import CloseIcon from '@mui/icons-material/Close';
import './modalMain.scss';
import { useNavigate } from 'react-router-dom';
import { fetchAuthSession, getCurrentUser } from 'aws-amplify/auth';


export const AddManagedAccount = ({ isOpen, onClose, groupName }) => {
    // const [groupName,setGroupName] = useState('') 
    // let groupName = "test";
    const [name, setName] = useState('');
    const [dob, setDob] = useState('');
    const [race, setRace] = useState('');
    const [gender, setGender] = useState('none');
    const [location, setLocation] = useState('');
    const [photoUrl, setPhotoUrl] = useState('');
    const [mainAccount, setMainAccount] = useState('');
    const [userToken, setUserToken] = useState(null);
    const navigate = useNavigate();

    const getUserToken = async () => {
        try {
            const session = await fetchAuthSession();
            const access_token = session.tokens.accessToken.toString();
            // console.log('Access Tokens',access_token);
            setUserToken(access_token);
            return access_token
        } catch {
            navigate("/login")
        }
    };

    useEffect(() => {
        getUserToken();
    }, [])

    useEffect(() => {
        setName('');
        setDob('');
        setRace('None');
        setGender('None');
        setLocation('');
        setPhotoUrl('');
        setMainAccount('No');
    }, [])

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = { name, dob, race, gender, location, photoUrl, mainAccount, userToken };

        try {
            const response = await fetch("https://api.weathervaneintel.com/api/api/addmanagedaccount", {
                method: 'POST',
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formData)
            });

            if (response.status === 403) {
                // User is unauthorized, redirect to /login
                navigate("/login");
                return; // stop further execution
            }

            if (!response.ok) {
                // Optional: handle other errors gracefully
                console.warn("API error:", response.status, response.statusText);
                return;
            }

            // Only clear form and close modal if request succeeded
            setName('');
            setDob('');
            setRace('None');
            setGender('None');
            setLocation('');
            setPhotoUrl('');
            setMainAccount('No');

            onClose();

        } catch (err) {
            console.error("Network or fetch error:", err);
        }
    };

    if (!isOpen) {
        return null;
    } else {
        if (userToken === null) {
            return (
                <div className="loadingdiv">
                    <h1>...Loading...</h1>
                </div>
            )
        } else {
            return ReactDOM.createPortal(
                <div className='modalMainContainer'>
                    <div className='modalContainer'>
                        <div className="mainPage">
                            <div className="modalheader">
                                <div className="left">
                                    <h1>Add Account:</h1>
                                </div>
                                <div className="right" onClick={onClose}>
                                    <button><CloseIcon /></button>
                                </div>
                            </div>
                            <div className="groupform">
                                <form onSubmit={handleSubmit}>
                                    <div className="formbox">
                                        <div className="formlabel">
                                            <label>Name</label>
                                        </div>
                                        <div className="forminput">
                                            <input
                                                type="text"
                                                name="Name"
                                                value={name}
                                                onChange={(e) => setName(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="formbox">
                                        <div className="formlabel">
                                            <label>Date of Birth</label>
                                        </div>
                                        <div className="forminput">
                                            <input
                                                type="text"
                                                name="Date of Birth"
                                                value={dob}
                                                onChange={(e) => setDob(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="formbox">
                                        <div className="formlabel">
                                            <label>Location</label>
                                        </div>
                                        <div className="forminput">
                                            <input
                                                type="text"
                                                name="Location"
                                                value={location}
                                                onChange={(e) => setLocation(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="formbox">
                                        <div className="formlabel">
                                            <label>Photo Url</label>
                                        </div>
                                        <div className="forminput">
                                            <input
                                                type="text"
                                                name="photourl"
                                                value={photoUrl}
                                                maxLength={255}
                                                onChange={(e) => setPhotoUrl(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="formbox">
                                        <div className="formlabel">
                                            <label>Race</label>
                                        </div>
                                        <div className="forminput">
                                            <select onChange={(e) => setRace(e.target.value)}>
                                                <option Value="None">None</option>
                                                <option value="Black">Black</option>
                                                <option value="White">White</option>
                                                <option value="Asian">Asian</option>
                                                <option value="Other">Other</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="formbox">
                                        <div className="formlabel">
                                            <label>Gender</label>
                                        </div>
                                        <div className="forminput">
                                            <select onChange={(e) => setGender(e.target.value)}>
                                                <option Value="None">None</option>
                                                <option value="male">Male</option>
                                                <option value="Female">Female</option>
                                                <option value="Other">Other</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="formbox">
                                        <div className="formlabel">
                                            <label>Main Account?</label>
                                        </div>
                                        <div className="forminput">
                                            <select onChange={(e) => setMainAccount(e.target.value)}>
                                                <option Value="No">No</option>
                                                <option value="Yes">Yes</option>
                                            </select>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="submitbutton">
                                <button onClick={handleSubmit}>Add Misattribution Account</button>
                            </div>

                        </div>

                    </div>
                </div>,
                document.getElementById("portal")
            )
        }
    }
}
